import React from 'react';
import PropTypes from 'prop-types';
import { Typography, TextField, Box } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';

const PF2MNumericField = ({
  value,
  disabled,
  onChange,
  classes,
  description,
  placeholder,
  size,
  textFieldProps,
  helperText,
  error,
  style,
  type,
}) => {
  const handleChange = (e) => {
    if (type === 'number') {
      const newValue = e.target.value;
      const numberValue = Number(newValue);

      if (newValue === '' || numberValue < 0) {
        onChange('');
        return;
      }

      if (!Number.isNaN(numberValue)) {
        onChange(numberValue);
      }
    } else {
      onChange(e.target.value);
    }
  };

  const { inputComponent, ...customInputProps } = textFieldProps;

  return (
    <Box className={classes.boxForm}>
      {description && (
        <Typography className={classes.formDescription}>
          {description}
        </Typography>
      )}

      <TextField
        placeholder={placeholder}
        InputProps={{
          min: 0,
          inputComponent,
          ...customInputProps,
        }}
        disabled={disabled}
        onChange={handleChange}
        value={value}
        type={type}
        variant="outlined"
        size={size}
        className={classes.numericFieldWrapper}
        helperText={helperText}
        error={error}
        style={style}
      />
    </Box>
  );
};

PF2MNumericField.propTypes = {
  classes: PropTypes.object,
  value: PropTypes.any,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  description: PropTypes.string,
  size: PropTypes.string,
  textFieldProps: PropTypes.object,
  helperText: PropTypes.string,
  error: PropTypes.bool,
  style: PropTypes.object,
  type: PropTypes.string,
};

PF2MNumericField.defaultProps = {
  classes: {},
  value: '',
  onChange: () => {},
  placeholder: '',
  disabled: false,
  description: '',
  size: 'small',
  textFieldProps: {},
  helperText: '',
  error: false,
  style: {},
  type: 'number',
};

export default withStyles(styles)(PF2MNumericField);
